var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.zhCN}},[_c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),(_vm.isDownLoadingData.status)?_c('DownLoadModal',{attrs:{"tipWords":_vm.isDownLoadingData.tipWords}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }